import BootCheckbox from "components/common/custom/forms/BootCheckbox";
import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import MultiSelect from "components/common/MultiSelect";
import WizardModal from "components/wizard/WizardModal";
import { motion } from "framer-motion";
import {
  GetAllDropDownData,
  GetInsuranceList,
} from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import {
  GetAllClaimPreAuthAllList,
  GetAllPractitonerList,
  GetAllPreauthorizationType,
  GetAllProviderName,
} from "features/preauthorization/config/preauthorizationApi";
import { processSupportingInfo } from "features/preauthorization/utils";
import React, { useEffect, useState } from "react";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ClaimRequestPractitioner from "./ClaimRequestPractitioner";
import { useParams, useSearchParams } from "react-router-dom";
import {
  handlePreauthFormData,
  handleResetCreateClaim,
} from "../../../config/claimSlice";
import { handleResetPatientSearch } from "features/eliglibility/eliglibility-check/config/eligibilityCheckSlice";

import { handleResetAll } from "../../../../preauthorization/config/preauthorizationSlice";
import { useLocation } from "react-router-dom";
const imageContext = require.context("assets/img/insurance", false, /\.png$/);
const ClaimRequest = ({
  watch,
  setValue,
  control,
  errors,
  setError,
  clearErrors,
  touchedFields,
}) => {
  const dispatch = useDispatch();
  const {
    visitReasons,
    preauthorizationType,
    preauthorizationSubType,
    providerName,
    viewPreauthorizationInfo,
    practitionerList,
    preauthorizationEligibility,
    preauthorizationRequest,
    processPriority,
  } = useSelector((state) => state.preauthorization);

  const { stepFormData, claimRequestData } = useSelector(
    (state) => state.claim
  );

  const { singleEligibilityData } = useSelector(
    (state) => state.eligibilityCheckList
  );

  const preauthRequest = viewPreauthorizationInfo?.provider_request;

  const { genderList } = useSelector((state) => state.eligibilityCheck);

  const { insuranceList } = useSelector((state) => state.eligibilityCheck);
  const location = useLocation();
  const { id } = useParams();
  const [searchParams] = useSearchParams();

  const [filteredSubTypes, setFilteredSubTypes] = useState([]);
  const [showPayerAlert, setShowPayerAlert] = useState(false);
  const [mergedSpecialities, setMergedSpecialities] = useState([]);
  const [showTypeAlert, setShowTypeAlert] = useState(false);
  const [menuStates, setMenuStates] = useState({
    type: false,
    subType: false,
    practitioner: false,
  });

  const watchPreauthType = watch("claim_type");
  const referralType = watch("visit_reason")?.visitreas_code === "referral";
  const preauth = searchParams.get("preauth") === "true";
  const eligibility = searchParams.get("eligibility") === "true";
  const isNCHI =
    watch("payer")?.insurance_company_id === 41 || watch("payer")?.value === 41;

  const claimRequest =
    claimRequestData?.entry?.find(
      (item) => item?.resource?.resourceType === "Claim"
    ) ||
    preauthorizationRequest?.entry?.find(
      (item) => item?.resource?.resourceType === "Claim"
    );

  const vitalDetails = processSupportingInfo(
    claimRequest?.resource?.supportingInfo
  );

  const coverageEligibility = preauthorizationEligibility?.entry?.find(
    (item) => item?.resource?.resourceType === "CoverageEligibilityResponse"
  )?.resource;

  const eligibilityID = coverageEligibility?.request?.identifier?.value;

  const visitReason = vitalDetails["reason-for-visit"];
  const periorityCode = claimRequest?.resource?.priority?.coding[0]?.code;
  const selectedPayer = watch("payer");
  const handleTypeMenuToggle = (isOpen) => {
    // 1) if opening & no payer → show modal & DO NOT open dropdown
    if (isOpen && !watch("payer")) {
      setShowPayerAlert(true);
      return setMenuStates((prev) => ({ ...prev, type: false }));
    }
    // 2) otherwise let it open/close
    setMenuStates((prev) => ({ ...prev, type: isOpen }));
  };

  const handleSubTypeMenuToggle = (isOpen) => {
    if (isOpen && !watch("claim_type")) {
      setShowTypeAlert(true);
      return setMenuStates((prev) => ({ ...prev, subType: false }));
    }
    setMenuStates((prev) => ({ ...prev, subType: isOpen }));
  };
  const prescription = watch("prescription");
  const payer = watch("payer");

  useEffect(() => {
    if (prescription && payer) {
      const preauthSub = preauthorizationSubType?.filter(
        (item) => item?.claimsub_types_id === 2
      );

      setValue(
        "claim_type",
        preauthorizationType?.find((item) => item?.claim_types_id === 4)
      );

      if (preauthSub?.length) {
        setValue("claim_sub_type", {
          claimsub_types_id: preauthSub[0].claimsub_types_id,
          claimsub_types_code: preauthSub[0].claimsub_types_code,
          claimsub_types_name: preauthSub[0].claimsub_types_name,
        });
      }
      clearErrors("claim_type", null);
      clearErrors("claim_sub_type", null);
    } else if (payer && isNCHI) {
      setValue(
        "claim_type",
        preauthorizationType?.find((item) => item?.claim_types_id === 1)
      );
    } else if (stepFormData) {
      setValue("claim_type", stepFormData?.claim_type);
      setValue("claim_sub_type", stepFormData?.claim_sub_type);
    }
  }, [
    prescription,
    payer,
    isNCHI,
    stepFormData,
    preauthorizationType,
    preauthorizationSubType,
  ]);

  useEffect(() => {
    if (watch("prescription")) return;

    const selectedType = watchPreauthType?.claim_types_name;

    if (!selectedType) {
      setFilteredSubTypes([]);
      setValue("claim_sub_type", null);
      return;
    }

    let updatedSubTypes = [];

    if (selectedType === "Institutional") {
      updatedSubTypes = preauthorizationSubType.filter(
        (sub) => sub.claimsub_types_name === "InPatient"
      );
    } else if (selectedType === "Professional") {
      updatedSubTypes = preauthorizationSubType.filter((sub) =>
        ["OutPatient", "Emergency"].includes(sub.claimsub_types_name)
      );
      // setValue("claim_sub_type", null);
    } else {
      updatedSubTypes = preauthorizationSubType.filter(
        (sub) => sub.claimsub_types_name === "OutPatient"
      );
    }

    setFilteredSubTypes(updatedSubTypes);

    // ✨ If only one match → auto-select it
    if (updatedSubTypes.length === 1) {
      setValue("claim_sub_type", {
        claimsub_types_id: updatedSubTypes[0].claimsub_types_id,
        claimsub_types_code: updatedSubTypes[0].claimsub_types_code,
        claimsub_types_name: updatedSubTypes[0].claimsub_types_name,
      });
    }
  }, [
    watchPreauthType,
    preauthorizationSubType,
    watch("prescription"),
    preauth,
    singleEligibilityData,
  ]);

  useEffect(() => {
    if (visitReasons?.length === 0) {
      dispatch(GetAllClaimPreAuthAllList());
    }
    if (preauthorizationType?.length === 0) {
      dispatch(GetAllPreauthorizationType());
    }
    if (practitionerList?.length === 0) {
      dispatch(GetAllPractitonerList());
    }
    if (insuranceList?.length === 0) {
      dispatch(GetInsuranceList());
    }
    if (genderList?.length === 0) {
      dispatch(GetAllDropDownData());
    }
    if (providerName?.length === 0) {
      dispatch(GetAllProviderName());
    }
  }, []);

  useEffect(() => {
    if (processPriority?.length > 0) {
      setValue(
        "priority_type",
        processPriority?.filter((item) => item?.prcspri_code === "normal")[0]
      );
    }
  }, [processPriority]);

  useEffect(() => {
    // Reset form data when preauth is false and URL changes
    if (!preauth && !eligibility && !stepFormData && !id) {
      dispatch(handlePreauthFormData({ check: "reset" }));
      dispatch(handleResetCreateClaim());
      dispatch(handleResetAll({ check: "reset" }));
      dispatch(handleResetPatientSearch());
    }
  }, [preauth, eligibility, stepFormData, location.pathname, id]);
  useEffect(() => {
    if (eligibility && !preauth) {
      setValue(
        "online_eligibility_ref_no",
        watch("eliginility_ref_no") || singleEligibilityData?.eligibility_id
      );
      setValue(
        "payer",
        watch("payer") ||
        insuranceList?.find(
          (item) =>
            item?.insurance_company_id ===
            singleEligibilityData?.insurance_company_id
        )
      );
    }
    if (preauthorizationEligibility?.id) {
      setValue(
        "online_eligibility_ref_no",
        watch("eliginility_ref_no") || eligibilityID
      );
    }

    if (preauth && !eligibility) {
      setValue(
        "payer",
        watch("payer") ||
        insuranceList?.find(
          (item) =>
            item?.insurance_company_id ===
            viewPreauthorizationInfo?.insurance_company_id
        )
      );

      setValue(
        "claim_type",
        watch("claim_type") ||
        preauthorizationType?.find(
          (item) =>
            item?.claim_types_code?.toLowerCase() ===
            viewPreauthorizationInfo?.claim_typenme?.toLowerCase()
        ) ||
        null
      );
      setValue(
        "prescription",
        touchedFields?.prescription
          ? watch("prescription")
          : preauthRequest?.prescription
      );
      setValue(
        "transferral",
        touchedFields?.transferral
          ? watch("transferral")
          : preauthRequest?.transfer
      );
      setValue(
        "claim_sub_type",
        watch("claim_sub_type") ||
        preauthorizationSubType?.find(
          (item) =>
            item?.claimsub_types_name?.toLowerCase() ===
            preauthRequest?.preauth_subtype?.toLowerCase()
        ) ||
        null
      );
      setValue(
        "priority_type",
        watch("priority_type") ||
        processPriority?.find(
          (item) => item?.prcspri_code === preauthRequest?.priority
        ) ||
        null
      );
      setValue(
        "prescription_ref_no",
        watch("prescription_ref_no") ||
        claimRequest?.resource?.prescription?.[0]?.display ||
        ""
      );
      setValue(
        "visit_reason",
        watch("visit_reason") ||
        visitReasons.find(
          (item) =>
            item?.visitreas_code?.toLowerCase() ===
            preauthRequest?.visitreasons
        )
      );
    } else if (stepFormData) {
      setValue("payer", stepFormData?.payer);
      setValue("visit_reason", stepFormData?.visit_reason);
      setValue("claim_type", stepFormData?.claim_type);
      setValue("claim_sub_type", stepFormData?.claim_sub_type);
      setValue("priority_type", stepFormData?.priority_type);
      setValue("date", stepFormData?.date);
      setValue(
        "healthcare_practitioner",
        stepFormData?.healthcare_practitioner
      );
      setValue("practices", stepFormData?.practices);
      setValue("practitioner_roles", stepFormData?.practitioner_roles);
      setValue("prescription", stepFormData?.prescription);
      setValue("eliginility_ref_no", stepFormData?.eliginility_ref_no);
      setValue("offline_preauth_date", stepFormData?.offline_preauth_date);
      setValue("offline_preauth_id", stepFormData?.offline_preauth_id);
      setValue("offline", stepFormData?.offline);
      setValue("transferral", stepFormData?.transferral);
      setValue("identifier_type", stepFormData?.identifier_type);
      setValue("prescription_ref_no", stepFormData?.prescription_ref_no);
    }
  }, [
    stepFormData,
    preauth,
    visitReason,
    visitReasons,
    insuranceList,
    eligibility,
    viewPreauthorizationInfo,
  ]);

  const getPayerImage = () => {
    const nameSource = selectedPayer?.insurance_direct
      ? selectedPayer?.payer_name
      : `${selectedPayer?.payer_name} - ${selectedPayer?.insurance_shname}`;
    if (!nameSource) return null;

    const formattedName = nameSource
      .toLowerCase()
      .replace(/ /g, "_")
      .replace(/[^a-z0-9_]/g, "");

    try {
      const matches = imageContext
        .keys()
        .filter((path) => path.toLowerCase().includes(formattedName));

      return matches.length > 0 ? imageContext(matches[0]) : null;
    } catch (e) {
      console.error("Image load error:", e);
      return null;
    }
  };
  const payerImage = getPayerImage();
  const payerOptions = insuranceList?.map((payer) => ({
    value: payer.insurance_company_id,
    label:
      payer.insurance_direct === 1
        ? payer.payer_name
        : `${payer.payer_name} - ${payer.insurance_shname}`,
    original: payer,
  }));

  console.log({ subType: watch("claim_sub_type") });

  return (
    <Row>
      {!watch("payer") ? (
        <Col xs={12} sm={6} md={4}>
          <Form.Group controlId="payer">
            <label className="form-label">
              Payer <span className="text-danger">*</span>
            </label>
            <Controller
              name="payer"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  options={payerOptions}
                  isClearable={true}
                  placeholder="Choose..."
                  onChange={(selected) => {
                    if (!selected) {
                      setValue("payer", null);
                      return;
                    }

                    const selectedPayer = selected.original;
                    setValue("payer", {
                      payer_name: selectedPayer.payer_name,
                      insurance_company_id: selectedPayer.insurance_company_id,
                      insurance_direct: selectedPayer.insurance_direct,
                      insurance_shname: selectedPayer.insurance_shname,
                    });
                    clearErrors("payer", null);
                  }}
                  value={
                    field.value
                      ? {
                        value: field.value.payer_id,
                        label:
                          field.value.insurance_direct === 1
                            ? field.value.payer_name
                            : `${field.value.payer_name} - ${field.value.insurance_shname}`,
                      }
                      : null
                  }
                />
              )}
            />
          </Form.Group>
        </Col>
      ) : (
        <Col xs={12} sm={6} md={4}>
          <Row className="align-items-center">
            <Col xs={6}>
              <Form.Group controlId="payer">
                <label className="form-label">
                  Payer <span className="text-danger">*</span>
                </label>
                <Controller
                  name="payer"
                  control={control}
                  rules={{ required: false }}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      options={payerOptions}
                      placeholder="Choose..."
                      isClearable={true}
                      onChange={(selected) => {
                        if (!selected) {
                          setValue("payer", null);
                          return;
                        }

                        const selectedPayer = selected.original;
                        setValue("payer", {
                          payer_name: selectedPayer.payer_name,
                          insurance_company_id:
                            selectedPayer.insurance_company_id,
                          insurance_direct: selectedPayer.insurance_direct,
                          insurance_shname: selectedPayer.insurance_shname,
                        });
                        clearErrors("payer", null);
                      }}
                      value={
                        field.value
                          ? {
                            value: field.value.payer_id,
                            label:
                              field.value.insurance_direct === 1
                                ? field.value.payer_name
                                : `${field.value.payer_name} - ${field.value.insurance_shname}`,
                          }
                          : null
                      }
                    />
                  )}
                />
              </Form.Group>
            </Col>
            <Col xs={6}>
              {payerImage && (
                <img
                  src={payerImage}
                  alt={selectedPayer?.payer_name}
                  style={{
                    width: "100%",
                    maxWidth: "80px",
                    objectFit: "contain",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              )}
            </Col>
          </Row>
        </Col>
      )}
      <Col xs={12} sm={6} md={4}>
        <Form.Group controlId="visit_reason">
          <label className="form-label">
            Visit Reason{!isNCHI && <span className="text-danger">*</span>}
          </label>
          <Controller
            name="visit_reason"
            control={control}
            isRequired={!isNCHI}
            rules={{ required: !isNCHI }}
            render={({ field }) => (
              <>
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isMulti={false}
                  size="sm"
                  isClearable={true}
                  options={visitReasons?.map((visit) => ({
                    value: visit.visitreas_code,
                    label: visit.visitreas_name,
                  }))}
                  placeholder="Choose..."
                  //   className={error ? "is-invalid" : ""}
                  value={
                    field.value
                      ? {
                        value: field.value.visitreas_code,
                        label: field.value.visitreas_name,
                      }
                      : null
                  }
                  onChange={(selected) => {
                    setValue(
                      "visit_reason",
                      selected
                        ? {
                          visitreas_name: selected?.label,
                          visitreas_code: selected?.value,
                        }
                        : null
                    );
                    clearErrors("visit_reason", null);
                  }}
                />
              </>
            )}
          />
        </Form.Group>
      </Col>
      <Col xs={12} sm={6} md={4}>
        <Row>
          <Col xs={9}>
            <Form.Group controlId="claim_type">
              <label className="form-label">
                Claim Type <span className="text-danger">*</span>
              </label>
              <Controller
                name="claim_type"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    options={preauthorizationType?.map((item) => ({
                      value: item.claim_types_id,
                      label: item.claim_types_name,
                    }))}
                    placeholder="Choose..."
                    // menuIsOpen={menuStates.type}
                    isClearable={true}
                    onMenuOpen={() => handleTypeMenuToggle(true)}
                    onMenuClose={() => handleTypeMenuToggle(false)}
                    disabled={watch("prescription") || isNCHI}
                    onChange={(selected) => {
                      setValue(
                        "claim_type",
                        selected
                          ? {
                            claim_types_name: selected.label,
                            claim_types_id: selected.value,
                          }
                          : null
                      );
                      clearErrors("claim_type", null);
                      clearErrors("claim_sub_type", null);
                    }}
                    value={
                      field.value
                        ? {
                          value: field.value.claim_types_id,
                          label: field.value.claim_types_name,
                        }
                        : null
                    }
                  />
                )}
              />
            </Form.Group>
          </Col>
          <Col xs={3}>
            <OverlayTrigger
              className="bg-warning"
              placement="bottom"
              flip
              overlay={
                <Tooltip className="bg-warning rounded text-warning">
                  Make a prescription request
                </Tooltip>
              }
            >
              <div>
                <BootCheckbox
                  name="prescription"
                  label="Prescription"
                  disabled={isNCHI}
                  control={control}
                  size="lg"
                />
              </div>
            </OverlayTrigger>
          </Col>
        </Row>
      </Col>
      {/* Preauthorization Sub Type Field */}
      <Col xs={12} sm={6} md={4}>
        <Form.Group controlId="claim_sub_type">
          <label className="form-label">
            Claim Sub Type <span className="text-danger">*</span>
          </label>
          <Controller
            name="claim_sub_type"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                options={filteredSubTypes.map((item) => ({
                  value: item?.claimsub_types_id,
                  label: item?.claimsub_types_name,
                  code: item?.claimsub_types_code,
                }))}
                placeholder="Choose..."
                menuIsOpen={menuStates.subType}
                disabled={watch("prescription") || isNCHI}
                isClearable={true}
                onMenuOpen={() => handleSubTypeMenuToggle(true)}
                onMenuClose={() => handleSubTypeMenuToggle(false)}
                onChange={(selected) => {
                  setValue(
                    "claim_sub_type",
                    selected
                      ? {
                        claimsub_types_name: selected.label,
                        claimsub_types_id: selected.value,
                        claimsub_types_code: selected.code,
                      }
                      : null
                  );
                  clearErrors("claim_sub_type", null);
                }}
                value={
                  field.value
                    ? {
                      value: field.value.claimsub_types_id,
                      label: field.value.claimsub_types_name,
                      code: field.value.claimsub_types_code,
                    }
                    : null
                }
              />
            )}
          />
        </Form.Group>
      </Col>
      <Col xs={12} sm={6} md={4}>
        <Form.Group controlId="payer">
          <label className="form-label">
            Priority Type <span className="text-danger">*</span>
          </label>
          <Controller
            name="priority_type"
            control={control}
            isRequired={true}
            rules={{ required: true }}
            render={({ field }) => (
              <>
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isClearable={true}
                  isMulti={false}
                  size="sm"
                  options={processPriority?.map((item) => ({
                    value: item.prcspri_code,
                    label: item.prcspri_name,
                  }))}
                  placeholder="Choose..."
                  //   className={error ? "is-invalid" : ""}
                  value={
                    field.value
                      ? {
                        value: field.value.prcspri_code,
                        label: field.value.prcspri_name,
                      }
                      : null
                  }
                  onChange={(selected) => {
                    setValue(
                      "priority_type",
                      selected
                        ? {
                          prcspri_name: selected?.label,
                          prcspri_code: selected?.value,
                        }
                        : null
                    );
                    clearErrors("priority_type", null);
                  }}
                />
              </>
            )}
          />
        </Form.Group>
      </Col>
      <Col xs={12} sm={6} md={4}>
        <BootDatePicker
          name="date"
          label="Date"
          size="sm"
          control={control}
          isRequired={true}
          rules={{ required: "Visit Date is Required" }}
          placeholder="dd-mm-yyyy hh:mm"
          dateFormat="dd-MM-yyyy hh:mm A"
          timeIntervals={15}
          showTimeSelect
          selected={watch("date")}
        />
      </Col>

      {!referralType &&
        (watch("offline") ? (
          <>
            <Col xs={12} sm={6} md={4}>
              <TextInput
                name="offline_eligibility_ref_no"
                placeholder="Offline Eligibility Ref. No"
                label="Offline Eligibility Ref. No"
                size="sm"
                control={control}
                required={false}
                rules={{ required: false }}
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <BootDatePicker
                name="offline_eligibility_date"
                label="Offline Eligibility Date"
                size="sm"
                control={control}
                rules={{ required: watch("offline_eligibility_ref_no") }}
                selected={watch("offline_eligibility_date")}
                onChange={(newValue) =>
                  setValue("offline_eligibility_date", newValue)
                }
                placeholder="dd/mm/yyyy"
                isRequired={watch("offline_eligibility_ref_no")}
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Row>
                <Col xs={12} md={6}>
                  <BootCheckbox
                    name="offline"
                    label="Offline"
                    control={control}
                    size="lg"
                  />
                </Col>
              </Row>
            </Col>
          </>
        ) : (
          <>
            <Col xs={12} sm={6} md={4}>
              <Row className="align-items-center">
                <Col xs={9}>
                  <TextInput
                    name="online_eligibility_ref_no"
                    label="Online Eligibility Ref No"
                    control={control}
                    // disabled={eligibility}
                    size="sm"
                    placeholder="Online Eligibility Ref No"
                  />
                </Col>
                <Col xs={3}>
                  <BootCheckbox
                    name="offline"
                    label="Offline"
                    control={control}
                    size="lg"
                  />
                </Col>
              </Row>
            </Col>
          </>
        ))}
      <ClaimRequestPractitioner
        control={control}
        setValue={setValue}
        watch={watch}
        mergedSpecialities={mergedSpecialities}
        setError={setError}
        clearErrors={clearErrors}
      />
      {referralType && (
        <motion.div
          style={{ border: "2px solid #d9f8eb" }}
          className="rounded p-3 position-relative  mt-3"
          initial={{ opacity: 0, y: 50 }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.5 }}
        >
          {/* Floating Badge Header */}
          <div className="position-absolute top-0 start-40 translate-middle-y px-2">
            <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
              <span className="fs-11">Referral Info</span>
            </span>
          </div>

          {/* Form Row */}
          <Row className="align-items-end">
            <Col xs={12} sm={6} md={3}>
              <TextInput
                name="preauthorization_ref_no"
                label="Preauthorization Ref No."
                control={control}
                size="sm"
                required={referralType}
                rules={{ required: referralType }}
                placeholder="Preauthorization Ref No"
              />
            </Col>

            <Col xs={12} sm={6} md={3}>
              <TextInput
                errors={errors}
                name="referral_provider_practitioner"
                label="Referral Provider/Practitioner"
                control={control}
                size="sm"
                placeholder="Referral Provider/Practitioner"
              />
            </Col>

            <Col xs={12} sm={6} md={3}>
              <label className="form-label">Provider Name</label>
              <Controller
                name="provider_name"
                control={control}
                render={({ field, ref }) => (
                  <MultiSelect
                    {...field}
                    ref={ref}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isMulti={false}
                    value={
                      field?.value
                        ? {
                          value: field?.value?.nphprov_cchiid,
                          label: field?.value?.nphprov_name,
                        }
                        : null
                    }
                    isClearable={true}
                    formatOptionLabel={({ label, value }) => (
                      <div>{`(${value}) - ${label}`}</div>
                    )}
                    options={providerName?.map((item) => ({
                      value: item?.nphprov_cchiid,
                      label: item?.nphprov_name,
                    }))}
                    onChange={(selected) => {
                      setValue(
                        "provider_name",
                        selected
                          ? {
                            nphprov_cchiid: selected?.value,
                            nphprov_name: selected?.label,
                          }
                          : null
                      );
                    }}
                    placeholder="Choose ..."
                  />
                )}
              />
            </Col>
          </Row>

          {/* Modals */}
        </motion.div>
      )}
      <WizardModal
        modal={showPayerAlert}
        setModal={() => setShowPayerAlert(false)}
        title="Payer Not Selected"
        description="Please select the Payer first before choosing Preauthorization Type."
      />
      <WizardModal
        modal={showTypeAlert}
        setModal={() => setShowTypeAlert(false)}
        title="Type Not Selected"
        description="Please select Preauthorization Type first before choosing Sub Type."
      />
      {watch("claim_type")?.claim_types_id === 3 && (
        <motion.div
          style={{ border: "2px solid #d9f8eb" }}
          className="rounded p-3 position-relative  mt-3"
          initial={{ opacity: 0, y: 50 }}
          animate={{
            opacity: 1,
            y: 0,
          }}
          exit={{ opacity: 0, y: 50 }}
          transition={{ duration: 0.5 }}
        >
          {/* Floating Badge Header */}
          <div className="position-absolute top-0 start-40 translate-middle-y px-2">
            <span className="badge shadow-sm d-flex align-items-center justify-content-center badge-subtle-success">
              <span className="fs-11">Prescription Details</span>
            </span>
          </div>

          {/* Form Row */}
          <Row className="align-items-end g-3 pt-3">
            <Col xs={12} sm={6} md={3}>
              <TextInput
                errors={errors}
                name="prescription_ref_no"
                label="Prescription Ref No."
                control={control}
                size="sm"
                required={false}
                placeholder="Prescription Ref No"
              />
            </Col>
          </Row>
        </motion.div>
      )}
    </Row>
  );
};

export default ClaimRequest;
